module.exports = __webpack_public_path__ + "static/media/tarot-card-1.5b0765b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-1.jpg
// module id = 1542
// module chunks = 0